/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useEffect, useContext, useState, useCallback } from 'react';
import Api from '../../../apis/meshApi';
import MikeButton from '../../mike-button';
import { GlobalContext } from '../../../store/Store';
import { IGlobalContext } from '../../app/AppWrapper';
import './ExportMeshPanel.css';
import ProviderDialog from '../../ProviderDialog';
import ProviderIcon from '../../ProviderIcon';
import Temperature from '../../../icons/Temperature.svg?react'
import BoundaryLine from '../../../icons/BoundaryLine.svg?react'
import UpArrow from '../../../icons/Up.svg?react'
import DownArrow from '../../../icons/Down.svg?react'
import Sun from '../../../icons/Sun.svg?react'
import DownloadCloud from '../../../icons/CloudExport.svg?react'
// import { debounce } from 'lodash-es';

//import { ModelType } from '../../../../generated/src/models';
import  ActionType  from '../../../store/ActionType';

import {
  PROGRESS_ITEM_TIMEOUT,
  IProgressItem,
} from '../../mike-topbar-progress-spinner';
import OlSelect from 'ol/interaction/Select';
import * as condition from 'ol/events/condition';
import { Checkbox, FormControlLabel, FormGroup, TextField, Tooltip } from '@mui/material';
import MikeProjectExplorerDialog from '../../mike-project-explorer/MikeProjectExplorerDialog';
import { getProjectContent } from '../../app/apiFunctions';
import {
  setProjectContentPage,
  setProjectContentOrder,
  setProjectContentOrderBy,
  setProjectContentRowsPerPage,
} from '../../../store/projectAction';
import {
  IGetProject,
  IGetCustomProject,
} from '../../../Models/IGetProject';
import { IGetProjectPath } from '../../../Models/IGetProject';
import { IGetDataset } from '../../../Models/IGetDataset';
import useLocalStorage from '../../app/Polling/PollingStorage';
import {
  BoundariesExpandedItem,
  ExtractionBuilderData,
  ForcingExpandedItem,
  ForcingsCollapsedItems,
  Provider,
  ProviderCollapsed,
  ProviderExpanded,
} from '../../../generated/src/models';
import { getSortedPageRows } from '../../TableComponents/support';
import { customProjectContentColumns } from '../../mike-project-explorer/MikeProjectContentTable/projectContentColumns';

const containerStyle = css` 
  display: flex;
`;
const checkboxesStyle = css` 
  padding: 4px 12px;
`;

const exportOptionsItemTextStyle = (disabled?: boolean) => {
  const style = {
    fontSize: '14px',
    lineHeight: '16px',
    cursor: 'pointer'
  }
  if (disabled){
    return {...style, color: '#86a2b3'}
  }
  else{
    return style
  }    
}



const CAPABILITIES = 'capabilities';
const CANREAD = 'canRead';

const EVENT_EXTRACT = 'Extract';
const EVENT_EXTRACT_MODEL_DESC = 'Model: ';
const EVENT_EXTRACT_INITIAL_CONDITIONS_DESC = 'Initial conditions: ';
const EVENT_EXTRACT_BOUNDARY_CONDITIONS_DESC = 'Boundary conditions: ';
const EVENT_EXTRACT_FORCINGS_CONDITIONS_DESC = 'Forcings: ';

const MenuExport = () => {
  const [globalState, globalDispatch] = useContext(GlobalContext);
  const globalContext: IGlobalContext = { state: globalState, dispatch: globalDispatch };
  const [open, setOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const currentNavigationProject =
    globalState.projectContent && globalState.projectContent.currentNavigationProject;
  const projectContent = globalState.projectContent && globalState.projectContent.projectContent;
  const currentNavigationProjectPath =
    globalState.projectContent && globalState.projectContent.currentNavigationProjectPath;
  const order = globalState.projectContent ? globalState.projectContent.order : 'desc';
  const orderBy = globalState.projectContent && globalState.projectContent.orderBy;
  const page = globalState.projectContent && globalState.projectContent.page;
  const rowsPerPage = globalState.projectContent && globalState.projectContent.rowsPerPage;
  const loadingProjectContent =
    globalState.projectContent && globalState.projectContent.loadingProjectContent;
  const [pageRows, setPageRows] = useState(Array<IGetCustomProject | IGetDataset>());
  const [projectToExportTo, setProjectToExportTo] = useState('');
 
  const seaLevelAdjustmentMIN = -100.0;
  const seaLevelAdjustmentMAX = 100.0;
  const seaLevelAdjustment = globalState.projectContent && globalState.mesh.seaLevelAdjustment;
  // const [seaLevelAdjustment, setSeaLevelAdjustment] = useState<number | string>(0);

  const [provider, setProvider] = useState<Provider | undefined>();
  const openDialog = (value: Provider) => () => {
    setProvider(value);
  };
  const closeDialog = () => setProvider(undefined);

  const [selectInteraction, setSelectInteraction] = React.useState(null);
  const [, setPollingSettings] = useLocalStorage('polling-settings');

  useEffect(() => {
    if ((globalState.map as any).olMap) {
      const select = new OlSelect({ condition: condition.never });
      if (selectInteraction !== null) {
        (globalState.map as any).olMap.removeInteraction(selectInteraction);
      }
      setSelectInteraction(select);
      (globalState.map as any).olMap.addInteraction(select);
      globalState.mesh.saveForcingsInNativeGridResolution = true;
      if (globalState.project.currentProject) {
        setProjectToExportTo(globalState.project.currentProject.id);
      }
    }
  }, [globalState.mesh.features]);

  const [showBoundaryConditions, setShowBoundaryConditions] = useState(false);
  const [showInitialConditions, setShowInitialConditions] = useState(false);
  const [showForcingConditions, setShowForcingConditions] = useState(false);

  function checkProvidersIsSelected(list) {
    if (
      list.filter(e => {
        return e.selected === true;
      }).length > 0
    ) {
      return true;
    }
  }

  const highlightBoundaryEnter = item => {
    const features = globalState.mesh.features;

    for (let i = 0; i < features.length; i++) {
      if (parseInt(features[i].get('code')) === item.code) {
        features[i].set('Selected', true);
        selectInteraction.getFeatures().push(features[i]);
      }
    }
  };
  const highlightBoundaryLeave = () => {
    selectInteraction.getFeatures().clear();
  };

  const dateHelper = (date: string): string => {
    const d = new Date(date);
    let d2 = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const _userOffset = d2.getTimezoneOffset() * 60 * 1000;
    d2 = new Date(d2.getTime() - _userOffset);
    return d2.toISOString();
  };

  const trackExtraction = (modelType: string, extractionBuilderData: ExtractionBuilderData) => {
    try {
      let selectedForcings = new Array<string>();
      let selectedBoundaries = new Array<string>();
      let selectedInitialConditions = new Array<string>();
      if (extractionBuilderData) {
        const forcings = extractionBuilderData.forcings;
        if (forcings) {
          const collapsedForcings =
            forcings.forcingsCollapsed && forcings.forcingsCollapsed.forcingsCollapsedItems
              ? forcings.forcingsCollapsed.forcingsCollapsedItems
              : [];
          const expandedForcings =
            forcings.forcingsExpanded && forcings.forcingsExpanded.forcingsExpandedItems
              ? forcings.forcingsExpanded.forcingsExpandedItems
              : [];
          const activeForcing = forcings.isExpanded ? expandedForcings : collapsedForcings;
          activeForcing.forEach((f: ForcingExpandedItem | ForcingsCollapsedItems) => {
            const providers = f.providers;
            if (providers) {
              const selectedProviders = providers.filter(
                (p: ProviderExpanded | ProviderCollapsed) => p.selected && p.name
              );
              const providerNames = selectedProviders.map(
                (p: ProviderExpanded | ProviderCollapsed) =>
                  p.displayName ? p.displayName : p.name ? p.name : ''
              );
              selectedForcings = selectedForcings.concat(providerNames);
            }
          });
        }
        const boundaries = extractionBuilderData.boundaries;
        if (boundaries) {
          if (boundaries.isExpanded) {
            const expandedBoundaries = boundaries.boundariesExpanded?.boundariesExpandedItems
              ? boundaries.boundariesExpanded?.boundariesExpandedItems
              : [];
            expandedBoundaries.forEach((f: BoundariesExpandedItem) => {
              const providers = f.providers;
              if (providers) {
                const selectedProviders = providers.filter(
                  (p: ProviderExpanded) => p.selected && p.name
                );
                const providerNames = selectedProviders.map((p: ProviderExpanded) =>
                  p.displayName ? p.displayName : p.name ? p.name : ''
                );
                selectedBoundaries = selectedBoundaries.concat(providerNames);
              }
            });
          } else {
            const collapsedBoundaryProviders = boundaries.boundariesCollapsed?.providersCollapsed;
            if (collapsedBoundaryProviders) {
              const selectedProviders = collapsedBoundaryProviders.filter(
                (p: ProviderCollapsed) => p.selected && p.name
              );
              const providerNames = selectedProviders.map((p: ProviderCollapsed) =>
                p.displayName ? p.displayName : p.name ? p.name : ''
              );
              selectedBoundaries = selectedBoundaries.concat(providerNames);
            }
          }
        }
        const initialConditions = extractionBuilderData.initConditions;
        if (initialConditions) {
          const collapsedInitialConditions =
            initialConditions.initConditionsCollapsed &&
            initialConditions.initConditionsCollapsed.initConditionsCollapsedItems
              ? initialConditions.initConditionsCollapsed.initConditionsCollapsedItems
              : [];
          const expandedInitialConditions =
            initialConditions.initConditionsExpanded &&
            initialConditions.initConditionsExpanded.initConditionsExpandedItems
              ? initialConditions.initConditionsExpanded.initConditionsExpandedItems
              : [];
          const activeInitialConditions = initialConditions.isExpanded
            ? expandedInitialConditions
            : collapsedInitialConditions;
          activeInitialConditions.forEach(f => {
            const providers = f.providers;
            if (providers) {
              const selectedProviders = providers.filter(
                (p: ProviderExpanded | ProviderCollapsed) => p.selected && p.name
              );
              const providerNames = selectedProviders.map(
                (p: ProviderExpanded | ProviderCollapsed) =>
                  p.displayName ? p.displayName : p.name ? p.name : ''
              );
              selectedInitialConditions = selectedInitialConditions.concat(providerNames);
            }
          });
        }
      }

      const distinctFilter = (value, index, self) => {
        return self.indexOf(value) === index;
      };

      let initialConditionTracking = '';
      if (selectedInitialConditions.length > 0) {
        const distinct = selectedInitialConditions.filter(distinctFilter);
        initialConditionTracking =
          ', ' + EVENT_EXTRACT_INITIAL_CONDITIONS_DESC + distinct.join(', ');
      }
      let boundariesTracking = '';
      if (selectedBoundaries.length > 0) {
        const distinct = selectedBoundaries.filter(distinctFilter);
        boundariesTracking = ', ' + EVENT_EXTRACT_BOUNDARY_CONDITIONS_DESC + distinct.join(', ');
      }
      let forcingsTracking = '';
      if (selectedForcings.length > 0) {
        const distinct = selectedForcings.filter(distinctFilter);
        forcingsTracking = ', ' + EVENT_EXTRACT_FORCINGS_CONDITIONS_DESC + distinct.join(', ');
      }

      const _paq = (window._paq = window._paq || []);
      _paq.push([
        'trackEvent',
        EVENT_EXTRACT,
        EVENT_EXTRACT_MODEL_DESC +
          modelType +
          initialConditionTracking +
          boundariesTracking +
          ', ' +
          forcingsTracking,
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  async function executeMeshBoundaries() {
    const data: IProgressItem = {
      title: `Starting extraction`,
      id: 'ExtractionID',
      progressValue: 0,
      browserStep: 0,
    };

    globalDispatch({
      type: ActionType.ADDUP_POLLING_ITEM,
      data,
    });

    try {
      const response = await Api.startExtraction(
        {
          projectGuid: globalState.project.currentProject.id,
          destinationProjectGuid: projectToExportTo,
          meshName: globalState.mesh.meshName,
          modelType: globalState.mesh.modelType.replace(/\s+/g, ''),   
          startDate: dateHelper(globalState.mesh.extractionStartDate),        
          endDate: dateHelper(globalState.mesh.extractionEndDate),          
          initConditionsDate: dateHelper(globalState.mesh.extractionInitialDate),         
          saveForcingsInNativeGridResolution: globalState.mesh.saveForcingsInNativeGridResolution,         
          extrapolateSpatialGaps: globalState.mesh.extrapolateSpatialGaps,
          seaLevelAdjustment: globalState.mesh?.seaLevelAdjustment,
        },
        globalState.data.extractionbuilderdata
      );
      trackExtraction(globalState.mesh.modelType, globalState.data.extractionbuilderdata);

      globalDispatch({
        type: ActionType.SET_POLLING_UPDATE,
        data: response.data,
      });
      setPollingSettings([...globalState.pollingIds, response.data]);
      data.id = response.data.toString();

      globalDispatch({
        type: ActionType.ADDUP_POLLING_ITEM,
        data: { ...data, progressValue: 0 },
      });
    } catch (e) {
      console.log('error: ', e.message);
      globalDispatch({
        type: ActionType.SET_MESSAGE,
        message: `Failed to call the extraction service: ${e.message}`,
      });
      globalDispatch({ type: ActionType.SET_MESSAGE_TYPE, messagetype: 'error' });
      globalDispatch({ type: ActionType.SET_SHOW_MESSAGE, show: true });
      globalDispatch({
        type: ActionType.ADDUP_POLLING_ITEM,
        data: { ...data, error: true },
      });
      globalDispatch({
        type: ActionType.ADD_NOTIFICATION,
        data: {
          projectId: globalState.project.currentProject.projectGuid,
          notification: {
            title: 'Extraction failed',
            message: `Extraction failed`,
            time: Date.now(),
            error: true,
          },
        },
      });
      setTimeout(() => {
        globalDispatch({
          type: ActionType.RM_POLLING_ITEM,
          data,
        });
      }, PROGRESS_ITEM_TIMEOUT);
    }
  }

  const openProjectExplorer = async () => {
    globalDispatch(setProjectContentPage(0));
    globalDispatch(setProjectContentOrder('desc'));
    globalDispatch(setProjectContentOrderBy(''));
    setOpen(true);
    setProjectToExportTo(globalState.project.currentProject.id);
    await getProjectContent({
      projectID: globalState.project.currentProject.id,
      globalContext: globalContext,
    });
  };

  const onItemClick = async item => {
    if (CANREAD in item) {
      const projectItem: IGetCustomProject = item as IGetCustomProject;
      if (projectItem.canRead) {
        await getProjectContent({ projectID: item.id, globalContext: globalContext });
      }
      globalDispatch(setProjectContentPage(0));
      globalDispatch(setProjectContentOrder('desc'));
      globalDispatch(setProjectContentOrderBy(''));
      if (item.projectGuid) {
        setProjectToExportTo(item.projectGuid);
      }
    } else if (CAPABILITIES in item) {
      const projectItem: IGetProjectPath = item as IGetProjectPath;
      if (projectItem.capabilities.canListContent) {
        await getProjectContent({ projectID: item.id, globalContext: globalContext });
      }
      globalDispatch(setProjectContentOrder('desc'));
      globalDispatch(setProjectContentOrderBy(''));
      if (item.id) {
        setProjectToExportTo(item.id);
      }
    }
  };

  const onSelecteditemsChanged = useCallback(
    (selectedItems: (IGetProject | IGetCustomProject | IGetDataset)[]) => {
      setSelectedItems(selectedItems);
    },
    []
  );

  const onCancel = () => {
    setOpen(false);
  };
  const onOk = () => {
    executeMeshBoundaries();
    setOpen(false);
  };

  const onHandleChangePage = useCallback(
    (page: number) => {
      globalDispatch(setProjectContentPage(page));
    },
    [globalDispatch]
  );

  const onHandleChangeRowsPerPage = useCallback(
    (rowsPerPage: number) => {
      globalDispatch(setProjectContentRowsPerPage(rowsPerPage));
    },
    [globalDispatch]
  );

  const onHandleRequestSort = useCallback(
    (orderBy: string | ((item: any) => string | number), order: 'asc' | 'desc') => {
      globalDispatch(setProjectContentPage(0));
      globalDispatch(setProjectContentOrder(order));
      globalDispatch(setProjectContentOrderBy(orderBy));
    },
    [globalDispatch]
  );

  useEffect(() => {
    const folders = projectContent.filter(
      (content: IGetProject | IGetDataset | IGetCustomProject) => CANREAD in content
    );
    setPageRows(getSortedPageRows(folders, orderBy, order));
  }, [projectContent, orderBy, order]);

  useEffect(() => {
    if (open) {
      setSelectedItems(Array<IGetProject | IGetDataset>());
    }
  }, [open]);

  const changeExportForcingsInNativeResolution = (event: any) => {
    globalDispatch({
      type: ActionType.SET_SAVE_FORCINGS_IN_NATIVE_GRID_RESOLUTION,
      data: event.target.checked,
    });
  };

  const changeExportExtrapolateSpatialGaps = (event: any) => {
    globalDispatch({
      type: ActionType.SET_EXTRAPOLATE_SPATIAL_GAPS,
      data: event.target.checked,
    });
  };

  const canExportForcingsToNativeResolution =  (globalState.data.extractionbuilderdata &&
      !globalState.data.extractionbuilderdata.forcings.isExpanded &&
      globalState.data.selected &&
      globalState.data.selected.ModelForcings > 0) ||
    (globalState.data.extractionbuilderdata &&
      globalState.data.extractionbuilderdata.forcings.isExpanded &&
      globalState.data.selected &&
      globalState.data.selected.ExpModelForcings > 0);
  

  const canExtrapolateOutsideDataProviderCoverage = (globalState.data.extractionbuilderdata &&
      globalState.data.selected &&
      globalState.data.selected.BoundaryConditions > 0) ||
    (globalState.data.extractionbuilderdata &&
      globalState.data.selected &&
      globalState.data.selected.ExpBoundaryConditions > 0) ||
    (globalState.data.extractionbuilderdata &&
      globalState.data.selected &&
      globalState.data.selected.InitialConditions > 0) ||
    (globalState.data.extractionbuilderdata &&
      globalState.data.selected &&
      globalState.data.selected.ExpInitialConditions > 0)
  

  return (
    <>
      <div className="exportContainer">
        <div className="exportFooter">
          <div className="exportOptionsChecklist">
            <FormGroup css={checkboxesStyle}> 
              <Tooltip title="Export using native format grids for forcing. Uncheck to export with fully interpolated values.">
                <FormControlLabel control={<Checkbox disabled={!canExportForcingsToNativeResolution}
                  checked={globalState.mesh.saveForcingsInNativeGridResolution}
                  onChange={changeExportForcingsInNativeResolution}
                  color="secondary"
                  id="saveForcingsInNativeGridResolution"
                  />} label="Export forcings to native resolution" slotProps={
                    {typography: exportOptionsItemTextStyle(!canExportForcingsToNativeResolution)}}/>
                </Tooltip>
                <Tooltip title="Extrapolate values for model area elements, which are outside of data providers spatial domain coverage. Uncheck to extract delete values in elements.">
                  <FormControlLabel control={<Checkbox disabled={!canExtrapolateOutsideDataProviderCoverage}
                  checked={globalState.mesh.extrapolateSpatialGaps}
                  onChange={changeExportExtrapolateSpatialGaps}
                  color="secondary"
                  id="extrapolateSpatialGaps"
                  />} label="Extrapolate outside data provider coverage" slotProps={
                    {typography: exportOptionsItemTextStyle(!canExtrapolateOutsideDataProviderCoverage)}}/> 
                </Tooltip>           
            </FormGroup>            

              <div style={{ padding: '6px 0', display: 'flex', alignItems: 'center' }}>
                <label
                  style={{ fontSize: 14, color: '#0b4566', padding: '0 12px' }}
                  htmlFor="seaLevelAdjustment">
                  Sea level adjustment
                </label>
                <Tooltip title="Fixed value for adjustment of water surface elevation. (Positive value: Increase. Negative value: Decrease)">
                  <TextField
                    type="number"
                    id="seaLevelAdjustment"
                    value={seaLevelAdjustment}
                    slotProps={{htmlInput: {
                      style: { height: 20, padding: 0, width: '115px' },
                      min: seaLevelAdjustmentMIN,
                      max: seaLevelAdjustmentMAX,
                      step: 0.01,
                      inputMode: 'numeric',
                      pattern: '-?[0-9]+',
                    }}} // pattern="-?[0-9]+"  pattern: '[0-9]*',
                    onChange={e => {
                      let value = parseFloat(e.target.value);
                      if (value > seaLevelAdjustmentMAX) value = seaLevelAdjustmentMAX;
                      if (value < seaLevelAdjustmentMIN) value = seaLevelAdjustmentMIN;
                      //This next line makes it possible to write "-" in the input
                      //let val
                     //  if (isNaN(Number(seaLevelAdjustment)) && e.target.value === '') val = '';

                      globalDispatch({
                        type: ActionType.SET_EXTTRACTION_SEA_LEVEL_ADJUSTMENT,
                        data: isNaN(value) ? 0 : value,
                      });

                      //This next line makes it possible to write "-" in the input
                      // setSeaLevelAdjustment(isNaN(val) ? '' : value);
                    }}
                  />
                </Tooltip>
                <span style={{ fontSize: 14, color: '#0b4566', paddingLeft: 12 }}> meters</span>
              </div>    
          </div>

          {(globalState.data.extractionbuilderdata &&
            !globalState.data.extractionbuilderdata.boundaries.isExpanded &&
            globalState.data.selected &&
            globalState.data.selected.BoundaryConditions > 0) ||
          (globalState.data.extractionbuilderdata &&
            globalState.data.extractionbuilderdata.boundaries.isExpanded &&
            globalState.data.selected &&
            globalState.data.selected.ExpBoundaryConditions > 0) ||
          (globalState.data.extractionbuilderdata &&
            !globalState.data.extractionbuilderdata.initConditions.isExpanded &&
            globalState.data.selected &&
            globalState.data.selected.InitialConditions > 0) ||
          (globalState.data.extractionbuilderdata &&
            globalState.data.extractionbuilderdata.initConditions.isExpanded &&
            globalState.data.selected &&
            globalState.data.selected.ExpInitialConditions > 0) ||
          (globalState.data.extractionbuilderdata &&
            !globalState.data.extractionbuilderdata.forcings.isExpanded &&
            globalState.data.selected &&
            globalState.data.selected.ModelForcings > 0) ||
          (globalState.data.extractionbuilderdata &&
            globalState.data.extractionbuilderdata.forcings.isExpanded &&
            globalState.data.selected &&
            globalState.data.selected.ExpModelForcings > 0) ? (
            // <Tooltip title="Start data extraction. Output stored in MIKE Data Admin.">
              <MikeButton size="large" variant="contained" onClick={openProjectExplorer}>

                <div className="buttonContentWrapper">
                  <div className="buttonIconWrapper">
                    <DownloadCloud />
                  </div>
                  <div className="buttonTextWrapper">Export</div>
                </div>
              </MikeButton>
            // </Tooltip>
          ) : (
            // <Tooltip title="Select data to enable extraction.">
              <MikeButton variant="contained" size="large" disabled>
                <div className="buttonContentWrapper">
                  <div className="buttonIconWrapper">
                    <DownloadCloud />
                  </div>
                  <div className="buttonTextWrapper">Export</div>
                </div>
              </MikeButton>
            // </Tooltip>
          )}
        </div>
        <ul className="exportConditionsSummary scrollableContent">
          <li>
            {/* <Tooltip title="Summary of selections for boundary condition data extraction"> */}
              <div
                className="exportCategory"
                onClick={() => setShowBoundaryConditions(!showBoundaryConditions)}>
                Boundary conditions
                {globalState.data.extractionbuilderdata &&
                !globalState.data.extractionbuilderdata.boundaries.isExpanded &&
                globalState.data.selected
                  ? ' (' + globalState.data.selected.BoundaryConditions + ')'
                  : ''}
                {globalState.data.extractionbuilderdata &&
                globalState.data.extractionbuilderdata.boundaries.isExpanded &&
                globalState.data.selected
                  ? ' (' + globalState.data.selected.ExpBoundaryConditions + ')'
                  : ''}
                {showBoundaryConditions && <UpArrow />}
                {!showBoundaryConditions && <DownArrow />}
              </div>
            {/* </Tooltip> */}
            {/* Boundaries Boundaries Boundaries Boundaries */}
            <div className={showBoundaryConditions ? '' : 'hideCategory'}>
              {globalState.data.extractionbuilderdata &&
              globalState.data.extractionbuilderdata.boundaries.isExpanded
                ? globalState.data.extractionbuilderdata.boundaries.boundariesExpanded.boundariesExpandedItems.map(
                    (item, i) => {
                      const Item = (
                        <div
                          key={i}
                          className="panelItem itemBorder noPadding contentFlex groupedStyle"
                          onMouseEnter={() => highlightBoundaryEnter(item)}
                          onMouseLeave={() => highlightBoundaryLeave()}>
                          <div className="panelItemIcon">
                            <BoundaryLine />
                            <div className="circle"></div>
                          </div>
                          <div className="panelItemContent">{item.name} </div>
                        </div>
                      );

                      const Providers = item.providers.map((item, j) => {
                        if (item.selected === true) {
                          return (
                            <div key={j} className="panelItem itemBorder noPadding">
                              <div className="contentFlex">
                                <div className="panelItemPadding"></div>
                                <div className="panelItemIcon">
                                  <ProviderIcon onClick={openDialog(item)} provider={item} />
                                </div>
                                <div
                                  className="panelItemContent cursorPointer"
                                  onClick={openDialog(item)}>
                                  {item.displayName}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      });

                      if (checkProvidersIsSelected(item.providers)) {
                        return [Item, Providers];
                      }
                    }
                  )
                : ''}

              {globalState.data.extractionbuilderdata &&
              !globalState.data.extractionbuilderdata.boundaries.isExpanded &&
              checkProvidersIsSelected(
                globalState.data.extractionbuilderdata.boundaries.boundariesCollapsed
                  .providersCollapsed
              )
                ? globalState.data.extractionbuilderdata.boundaries.boundariesCollapsed.boundaryCollapsedItems.map(
                    (item, i) => {
                      const Items = (
                        <div
                          key={i}
                          className="panelItem itemBorder noPadding contentFlex"
                          onMouseEnter={() => highlightBoundaryEnter(item)}
                          onMouseLeave={() => highlightBoundaryLeave()}>
                          <div className="panelItemIcon">
                            <BoundaryLine />
                            <div className="circle"></div>
                          </div>

                          <div className="panelItemContent">{item.name}</div>
                        </div>
                      );
                      return Items;
                    }
                  )
                : ''}

              {globalState.data.extractionbuilderdata &&
              !globalState.data.extractionbuilderdata.boundaries.isExpanded
                ? globalState.data.extractionbuilderdata.boundaries.boundariesCollapsed.providersCollapsed.map(
                    (item, i) => {
                      const Providers = (
                        <div key={i} className="panelItem itemBorder noPadding">
                          <div className="contentFlex">
                            <div className="panelItemPadding"></div>
                            <div className="panelItemIcon">
                              <ProviderIcon onClick={openDialog(item)} provider={item} />
                            </div>
                            <div
                              className="panelItemContent cursorPointer"
                              onClick={openDialog(item)}>
                              {item.displayName}
                            </div>
                          </div>
                        </div>
                      );
                      if (item.selected === true) {
                        return [Providers];
                      }
                    }
                  )
                : ''}
            </div>
            {/* Boundaries Boundaries Boundaries Boundaries */}
          </li>
          <li>
            {/* <Tooltip title="Summary of selections for initial condition data extraction"> */}
              <div
                onClick={() => setShowInitialConditions(!showInitialConditions)}
                className="exportCategory">
                Initial conditions
                {globalState.data.extractionbuilderdata &&
                !globalState.data.extractionbuilderdata.initConditions.isExpanded &&
                globalState.data.selected
                  ? ' (' + globalState.data.selected.InitialConditions + ')'
                  : ''}
                {globalState.data.extractionbuilderdata &&
                globalState.data.extractionbuilderdata.initConditions.isExpanded &&
                globalState.data.selected
                  ? ' (' + globalState.data.selected.ExpInitialConditions + ')'
                  : ''}
                {showInitialConditions && <UpArrow />}
                {!showInitialConditions && <DownArrow />}
              </div>
            {/* </Tooltip> */}
            {/* Initial Initial Initial Initial */}
            <div className={showInitialConditions ? '' : 'hideCategory'}>
              {globalState.data.extractionbuilderdata &&
              globalState.data.extractionbuilderdata.initConditions.isExpanded
                ? globalState.data.extractionbuilderdata.initConditions.initConditionsExpanded.initConditionsExpandedItems.map(
                    (item, i) => {
                      const Item = (
                        <div
                          key={i}
                          className="panelItem itemBorder noPadding contentFlex groupedStyle">
                          <div className="panelItemIcon">
                            <Sun />
                          </div>
                          <div className="panelItemContent">{item.itemName} </div>
                        </div>
                      );

                      const Providers = item.providers.map((item, j) => {
                        if (item.selected === true) {
                          return (
                            <div key={j} className="panelItem itemBorder noPadding">
                              <div className="contentFlex">
                                <div className="panelItemPadding"></div>
                                <div className="panelItemIcon">
                                  <ProviderIcon onClick={openDialog(item)} provider={item} />
                                </div>
                                <div
                                  className="panelItemContent cursorPointer"
                                  onClick={openDialog(item)}>
                                  {item.displayName}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      });

                      if (checkProvidersIsSelected(item.providers)) {
                        return [Item, Providers];
                      }
                    }
                  )
                : ''}

              {globalState.data.extractionbuilderdata &&
              !globalState.data.extractionbuilderdata.initConditions.isExpanded
                ? globalState.data.extractionbuilderdata.initConditions.initConditionsCollapsed.initConditionsCollapsedItems.map(
                    (item, i) => {
                      const Items = (
                        <div key={i}>
                          {item.items.map((item, i) => (
                            <div key={i} className="panelItem itemBorder noPadding">
                              <div className="panelItemIcon">
                                <Sun />
                              </div>
                              <div className="contentFlex">{item}</div>
                            </div>
                          ))}
                          {item.providers.map((item, j) => {
                            if (item.selected === true) {
                              return (
                                <div key={j} className="panelItem itemBorder noPadding">
                                  <div className="contentFlex">
                                    <div className="panelItemPadding"></div>
                                    <div className="panelItemIcon">
                                      <ProviderIcon onClick={openDialog(item)} provider={item} />
                                    </div>
                                    <div
                                      className="panelItemContent cursorPointer"
                                      onClick={openDialog(item)}>
                                      {item.displayName}
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                      );

                      if (checkProvidersIsSelected(item.providers)) {
                        return [Items];
                      }
                    }
                  )
                : ''}
            </div>
            {/* Initial Initial Initial Initial */}
          </li>
          <li>
            {/* <Tooltip title="Summary of selections for model forcings data extraction"> */}
              <div
                onClick={() => setShowForcingConditions(!showForcingConditions)}
                className="exportCategory">
                Model forcings
                {globalState.data.extractionbuilderdata &&
                !globalState.data.extractionbuilderdata.forcings.isExpanded &&
                globalState.data.selected
                  ? ' (' + globalState.data.selected.ModelForcings + ')'
                  : ''}
                {globalState.data.extractionbuilderdata &&
                globalState.data.extractionbuilderdata.forcings.isExpanded &&
                globalState.data.selected
                  ? ' (' + globalState.data.selected.ExpModelForcings + ')'
                  : ''}
                {showForcingConditions && <UpArrow />}
                {!showForcingConditions && <DownArrow />}
              </div>
            {/* </Tooltip> */}
            {/* Forcing Forcing Forcing Forcing */}
            <div className={showForcingConditions ? '' : 'hideCategory'}>
              {globalState.data.extractionbuilderdata &&
              globalState.data.extractionbuilderdata.forcings.isExpanded
                ? globalState.data.extractionbuilderdata.forcings.forcingsExpanded.forcingsExpandedItems.map(
                    (item, i) => {
                      const Item = (
                        <div
                          key={i}
                          className="panelItem itemBorder noPadding contentFlex groupedStyle">
                          <div className="panelItemIcon">
                            <Temperature />
                          </div>
                          <div className="panelItemContent">{item.itemName} </div>
                        </div>
                      );

                      const Providers = item.providers.map((item, j) => {
                        if (item.selected === true) {
                          return (
                            <div key={j} className="panelItem itemBorder noPadding">
                              <div className="contentFlex">
                                <div className="panelItemPadding"></div>
                                <div className="panelItemIcon">
                                  <ProviderIcon onClick={openDialog(item)} provider={item} />
                                </div>
                                <div
                                  className="panelItemContent cursorPointer"
                                  onClick={openDialog(item)}>
                                  {item.displayName}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      });

                      if (checkProvidersIsSelected(item.providers)) {
                        return [Item, Providers];
                      }
                    }
                  )
                : ''}

              {globalState.data.extractionbuilderdata &&
              !globalState.data.extractionbuilderdata.forcings.isExpanded
                ? globalState.data.extractionbuilderdata.forcings.forcingsCollapsed.forcingsCollapsedItems.map(
                    (item, i) => {
                      const Items = (
                        <div key={i}>
                          {item.items.map((item, i) => (
                            <div key={i} className="panelItem itemBorder noPadding">
                              <div className="panelItemIcon">
                                <Temperature />
                              </div>
                              <div className="contentFlex">{item}</div>
                            </div>
                          ))}
                          {item.providers.map((item, j) => {
                            if (item.selected === true) {
                              return (
                                <div key={j} className="panelItem itemBorder noPadding">
                                  <div className="contentFlex">
                                    <div className="panelItemPadding"></div>
                                    <div className="panelItemIcon">
                                      <ProviderIcon onClick={openDialog(item)} provider={item} />
                                    </div>
                                    <div
                                      className="panelItemContent cursorPointer"
                                      onClick={openDialog(item)}>
                                      {item.displayName}
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                      );

                      if (checkProvidersIsSelected(item.providers)) {
                        return [Items];
                      }
                    }
                  )
                : ''}
            </div>
            {/* Forcing Forcing Forcing Forcing */}
          </li>
        </ul>
      </div>

      <ProviderDialog open={!!provider} provider={provider} onClose={closeDialog} />

      <div css={containerStyle}>
        <MikeProjectExplorerDialog
          columns={customProjectContentColumns}
          dialogTitle="Select export folder for extraction data"
          okButtonDisabled={false}
          okButtonLabel={'Export'}
          onCancel={onCancel}
          onOk={onOk}
          onChangePage={onHandleChangePage}
          onChangeRowsPerPage={onHandleChangeRowsPerPage}
          onHandleRequestSort={onHandleRequestSort}
          onItemClick={onItemClick}
          onSelectionChange={onSelecteditemsChanged}
          order={order}
          orderBy={orderBy}
          selectedItems={selectedItems}
          open={open}
          loading={loadingProjectContent}
          page={page}
          pagination={projectContent.length > 10}
          project={currentNavigationProject !== null ? currentNavigationProject : undefined}
          projectContent={pageRows}
          projectPath={currentNavigationProjectPath}
          rowsPerPage={rowsPerPage}
          selectable={false}
          totalCount={projectContent.length}
        />
      </div>
    </>
  );
};

export default MenuExport;
